<template>
  <div class="main-content berita">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">{{ getArticlesContentMetaTitle(articles) }}</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="news-container detail">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-md-offset-2">
            <div class="blog-posts single-post">
              <article class="post clearfix mb-0">
                <div class="entry-header">
                  <div class="post-thumb thumb">
                    <img
                      v-bind:src="getArticlesContentMetaPicture(articles)"
                      alt
                      class="img-responsive img-fullwidth"
                    />
                  </div>
                </div>
                <div class="entry-content mt-20">
                  <div class="media-body">
                    <div class="event-content pull-left flip">
                      <h3
                        class="entry-title text-theme-colored text-uppercase pt-0 mt-0"
                      >{{ getArticlesContent(articles).title }}</h3>
                      <div class="post-info mb-20">
                        <div class="author">
                          <b>{{ getUsername(articles) }}</b>
                        </div>
                        <div class="separator">|</div>
                        <div class="date">
                          <b>{{ getArticlesContent(articles).created_at }}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-html="getArticlesContentMetaDescriptionFull(articles)"></div>
                  <div class="mt-30 mb-0">
                    <h5 class="pull-left mt-10 mr-20 text-theme-colored">Share:</h5>
                    <ul class="styled-icons icon-circled m-0">
                      <li>
                        <a href target="_blank">Share</a>
                        <a
                          :href="'https://www.facebook.com/sharer/sharer.php?u=' + getShareUrl() "
                          target="_blank"
                          class="fb"
                        >
                          <i class="fa fa-facebook text-white"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ACTION_SET_ARTICLE } from "../store/repo/pages";
export default {
  metaInfo() {
    return {
      title: this.getArticlesContentMetaTitle(this.articles),
      meta: [
        { charset: "utf-8" },
        { property: "og:site_name", content: "RSUII Website" },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "rsuii.co.id" },
        {
          property: "og:description",
          content: this.getArticlesContentMetaDescription(this.articles),
        },
        {
          property: "og:title",
          vmid: "og:title",
          content: this.getArticlesContentMetaTitle(this.articles),
        },
        {
          vmid: "description",
          name: "description",
          content: this.getArticlesContentMetaDescription(this.articles),
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: this.getArticlesContentMetaKeywords(this.articles),
        },
      ],
    };
  },
  created() {
    this.slug = this.$route.params.slug;
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    getArticlesContent(data) {
      return data;
    },
    getShareUrl() {
      return window.location.href;
    },
    getUsername(data) {
      let username = data.user == undefined ? "" : data.user.username;
      return username;
    },
    getArticlesContentMetaTitle(data) {
      let meta = data.meta == undefined ? "" : data.meta;

      if (meta == "") return "";
      else return JSON.parse(meta).meta_title;
    },
    getArticlesContentMetaDescription(data) {
      let meta = data.meta == undefined ? "" : data.meta;

      if (meta == "") return "";
      else return JSON.parse(meta).meta_description;
    },
    getArticlesContentMetaDescriptionFull(data) {
      let meta = data.meta == undefined ? "" : data.meta;

      if (meta == "") return "";
      else return JSON.parse(meta).description;
    },
    getArticlesContentMetaKeywords(data) {
      let meta = data.meta == undefined ? "" : data.meta;

      if (meta == "") return "";
      else return JSON.parse(meta).meta_keywords;
    },
    getArticlesContentMetaPicture(data) {
      let meta = data.meta == undefined ? "" : data.meta;
      if (meta == "") return "";
      else {
        let meta_json = JSON.parse(meta);
        return meta_json.meta_picture == "" ||
          meta_json.meta_picture == "-" ||
          meta_json.meta_picture == null
          ? require("../assets/no-image.jpg")
          : meta_json.meta_picture;
      }
    },
    getArticle(slug) {
      const payload = {
        slug: this.$route.params.slug,
      };
      this.$store.dispatch(ACTION_SET_ARTICLE, payload);
    },
  },
  watch: {
    "$route.params.slug": {
      handler: function (value) {
        this.getArticle(value);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    articles() {
      return this.$store.getters.getArticle.data == undefined
        ? []
        : this.$store.getters.getArticle.data;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/BeritaDetail.vue